<template>
	<AppForm @submit="onSubmit" class="tw-mt-2 tw-max-w-[750px]">
		<div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
			<div>
				<div class="tw-mb-3 tw-text-[32px] tw-font-bold tw-text-gray-950">
					{{ $t('integrations.link-your-catalog-to-linker') }}
				</div>
				<div class="tw-text-2xl tw-font-medium tw-text-gray-950">
					{{ $t('integrations.link-your-catalog-to-linker-desc') }}
				</div>
			</div>

			<div class="tw-mb-4 tw-mt-3 tw-flex tw-gap-3">
				<AppInput
					class="tw-flex-1"
					v-model="form.catalog_name"
					:label="$t('integrations.catalog-name')"
					:rules="['required']"
				/>

				<AppInput
					class="tw-flex-1"
					v-model="form.catalog_id"
					:label="$t('integrations.catalog-id')"
					:rules="['required']"
				/>
			</div>

			<div class="tw-mb-3 tw-text-xl">
				<div class="tw-mb-1 tw-flex tw-gap-2">
					<p>
						<span>{{ $t('integrations.to-get-your-catalog-name-and-id-visit') }} </span>
						<a
							class="tw-mx-1 tw-text-blue-500 tw-underline hover:tw-underline"
							href="https://business.facebook.com/latest/whatsapp_manager/catalog/?nav_ref=whatsapp_manager&is_from_mbs=1&business_id=254843552892025&asset_id=357255454146186"
							target="_blank"
						>
							{{ $t('integrations.this-page') }}
						</a>
						<span
							>{{ $t('integrations.select-your-catalog-1-copy-the-name-2-copy-the-id-3') }}
						</span>
					</p>
				</div>
				<img :src="`${imgUrl}/link-your-catalog-to-linker.png`" class="tw-rounded-sm" />
			</div>

			<div class="tw-mt-7 tw-flex tw-flex-1 tw-justify-between">
				<AppButton
					:label="$t('integrations.confirm-data')"
					size="xl"
					class="tw-rounded-full"
					endIcon="assets/v2/image/icons/arrow-narrow-right.svg"
					:disabled="loading"
				/>

				<a v-if="configs.brand == 'Linker'" :href="needHelpUrl" target="_blank">
					<AppButton
						:label="$t('integrations.need-help')"
						variant="secondary"
						endIcon="assets/v2/image/icons/help-circle.svg"
						class="tw-rounded-full"
						size="xl"
                        type="button"
					/>
				</a>
			</div>
		</div>
	</AppForm>
</template>

<script setup>
import { ref } from 'vue';
import { WhatsAppMarketplace } from '@/v2/modules/integrations/entities/marketplaces/whatsapp.js';
import { useLinkMarketplaceStore } from '@/v2/modules/integrations/stores/link-marketplace';
import { configs } from '@/v2/system-configs';

const linkMarketplaceStore = useLinkMarketplaceStore();

const needHelpUrl =
	'https://www.linker.com.sa/help-center-articles-ar/how-to-link-whatsapp-catalog-with-linker-platform';
const loading = ref(false);
const imgUrl = 'assets/v2/image/whatsapp/catalog';
const form = ref({
	catalog_name: '',
	catalog_id: '',
});

const onSubmit = async () => {
	loading.value = true;
	try {
		await WhatsAppMarketplace.shareWhatsappCatalog(form.value);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		loading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
